import { AppIcon, ICON_SIZES } from '@backrs_ui/common-ui';

import { Box, SxProps, Theme } from '@mui/material';

type ChecklistItemStatusProps = Readonly<{
  isCompleted: boolean;
  isRequired: boolean;
}>;

export const ChecklistItemStatus = ({ isCompleted, isRequired }: ChecklistItemStatusProps) => {
  if (isCompleted) {
    return (
      <Box sx={iconContainerStyle}>
        <AppIcon iconName="Check" diameter="20px" color="Colors/Base/Black" />
      </Box>
    );
  }

  if (isRequired) {
    return (
      <Box sx={incompleteIconContainerStyle}>
        <AppIcon iconName="Plus" diameter="20px" color="Colors/Foreground/fg-error-primary" />
      </Box>
    );
  }

  return (
    <Box sx={incompleteIconContainerStyle}>
      <AppIcon iconName="Plus" diameter="20px" color="Colors/Foreground/fg-quinary" />
    </Box>
  );
};

const iconContainerStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  width: ICON_SIZES['28px'],
  height: ICON_SIZES['28px'],
  justifyContent: 'center',
};

const incompleteIconContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: ICON_SIZES['28px'],
  height: ICON_SIZES['28px'],
  border: `1px solid ${backrs.colors['Gray/300']}`,
  borderRadius: backrs.radius['radius-sm'],
});
